"use client";

import { useEffect } from "react";
import { isIOSDevice } from "@lib/utils/commonUtility";
import { usePathname } from "next/navigation";

export function ViewportMetaClient() {
    const pathname = usePathname();
    useEffect(() => {
        // Only run on client side after hydration
        const viewportMeta = document.querySelector('meta[name="viewport"]');
        if (viewportMeta && isIOSDevice()) {
            // Update viewport for iOS devices to prevent zoom
            viewportMeta.setAttribute(
                "content",
                "width=device-width, initial-scale=1, maximum-scale=1"
            );
        }
    }, [pathname]);

    // This component doesn't render anything
    return null;
}
